import {
	DRAWER_IMAGE_MIN_HEIGHT,
	DRAWER_IMAGE_MIN_WIDTH,
	type MarketingBannerModalProps
} from '@capsicum/features/feeds/shared';
import styled from 'styled-components';

import { useMarketingBannerTextColor } from '../../hooks/useMarketingBannerTextColor';

import { BannerImage, StyledText } from './MarketingBanner.styled';

export const MarketingBannerModal = ({
	backgroundImage,
	body = '',
	header = '',
	image = null,
	primaryAction,
	subtitle = '',
	theme
}: MarketingBannerModalProps) => {
	const { textColor } = useMarketingBannerTextColor({ theme });

	return (
		<S.Wrapper data-testid="marketing-banner-modal">
			{backgroundImage ? (
				<S.LinkContainer data-testid="marketingBannerModal-drawerImage-link" onClick={primaryAction}>
					<S.ImageContainer>
						<BannerImage
							alt="marketing-banner-carousel-drawer-image"
							blurhash={backgroundImage.blurHash}
							fill
							src={backgroundImage.url}
						/>
					</S.ImageContainer>
				</S.LinkContainer>
			) : (
				<>
					<S.Details>
						{subtitle && (
							<StyledText $color={textColor} aria-level={2} role="heading" variant="text4">
								{subtitle}
							</StyledText>
						)}

						{header && (
							<StyledText $color={textColor} aria-level={1} role="heading" variant="title5">
								{header}
							</StyledText>
						)}

						{body && (
							<StyledText $color={textColor} variant="text3">
								{body}
							</StyledText>
						)}
					</S.Details>

					{image && (
						<S.ImageContainer>
							<BannerImage
								$verticalObjectPosition="50%"
								alt="marketing-banner-carousel-image"
								blurhash={image.blurHash}
								fill
								src={image.url}
							/>
						</S.ImageContainer>
					)}
				</>
			)}
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		height: 100%;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
		gap: ${({ theme }) => theme.spacings.large};
	`;

	export const Details = styled.div`
		display: flex;
		text-align: center;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;

	export const ImageContainer = styled.div`
		flex: 1;
		width: 100%;
	`;

	export const LinkContainer = styled.div`
		height: 100%;
		min-height: ${DRAWER_IMAGE_MIN_HEIGHT}px;
		min-width: ${DRAWER_IMAGE_MIN_WIDTH}px;
		width: 100%;
		display: flex;
	`;
}
